import type { BuybackOrderDetails } from '@backmarket/http-api/src/api-specs-buyback/seller/refurbisher.types'
import {
  formatStatusTimeline,
  getStatusTimelineActiveStep,
} from '@backmarket/nuxt-layer-buyback/utils/adapters'
import { useFormatAddress } from '@backmarket/nuxt-module-address/useFormatAddress'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { getPhoneNumberInfos } from '@ds/components/InputPhone'

import { DEFAULT_DATA } from '~/scopes/buyback/pages/orderDetails/constants'

export const orderDetailsAdapter = (
  orderDetails: BuybackOrderDetails | undefined,
) => {
  if (!orderDetails) return DEFAULT_DATA
  const {
    order,
    product,
    shipping,
    statusTimeline,
    identityDocuments,
    instruction,
    actions,
  } = orderDetails
  const i18n = useI18n()
  const timeline = formatStatusTimeline(statusTimeline)
  const { tag, activeStep } = getStatusTimelineActiveStep(timeline)

  const firstName = shipping?.returnAddress?.firstName
  const lastName = shipping?.returnAddress?.lastName
  const fullName = firstName && lastName ? `${firstName} ${lastName}` : ''

  const { phoneNumber, companyName, ...returnAddress } =
    shipping.returnAddress ?? {}
  const { dial, nationalNumber } = getPhoneNumberInfos(
    phoneNumber || '',
    returnAddress.country,
  )
  const adaptedReturnAddress = {
    ...returnAddress,
    company: companyName,
    phone: nationalNumber,
    countryDialInCode: dial,
  }

  const identityDocumentsFiles = identityDocuments?.required
    ? identityDocuments.documents
    : []

  return {
    activeStep,
    timeline,
    id: order.id.toString(),
    product: {
      tag,
      title: product.title,
      image: product.image?.light,
      price: i18n.price(order.price),
      ...(order.counterOfferPrice
        ? { counterOfferPrice: i18n.price(order.counterOfferPrice) }
        : {}),
      customerAssessment: order?.customerAssessment,
    },
    customer: {
      phoneNumber,
      address: [fullName, ...useFormatAddress(adaptedReturnAddress)],
      trackingNumber: shipping.trackingNumber,
      transferCertificate: order.transferCertificateLink,
      identityDocumentsFiles,
    },
    instruction,
    actions,
  }
}
